let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('shop/orders/_mixins/cart').default
} catch (e) {
  //
}

export default mixins
